import React, { useState } from 'react';
import ReactDOM from 'react-dom/client'; // <-- import for React 18+

type ConfirmModalProps = {
  isOpen: boolean;
  keyWord: string;
  message: string;
  onClose: () => void;
  onSubmit: (key: string) => void;
};

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  keyWord,
  message,
}) => {
  const [key, setKey] = useState('');

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
      }}
    >
      <div style={{ background: '#fff', padding: 24, borderRadius: 8, minWidth: 300 }}>
        <h2>{message}</h2>
        <p>enter '{keyWord}' to confirm</p>
        <br />
        <input
          type="text"
          value={key}
          onChange={(e) => setKey(e.target.value)}
          style={{ width: '100%', marginBottom: 16, padding: 8 }}
          placeholder={`Enter '${keyWord}' to confirm`}
        />
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button onClick={onClose}>Cancel</button>
          <button
            onClick={() => {
              onSubmit(key);
              setKey('');
            }}
            disabled={!key}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

// Usage helper to "pause" until OK is pressed
export function showConfirmModal(keyWord: string, message: string): Promise<boolean | null> {
  return new Promise((resolve) => {
    const modalRoot = document.createElement('div');
    document.body.appendChild(modalRoot);

    const root = ReactDOM.createRoot(modalRoot);

    function cleanup() {
      root.unmount();
      document.body.removeChild(modalRoot);
    }

    const handleClose = () => {
      cleanup();
      resolve(null);
    };

    const handleSubmit = (key: string) => {
      cleanup();
      resolve(key === keyWord);
    };

    root.render(
      <ConfirmModal
        isOpen
        onClose={handleClose}
        onSubmit={handleSubmit}
        keyWord={keyWord}
        message={message}
      />
    );
  });
}
